import * as React from "react";

export function CircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 128c35.346 0 64-28.654 64-64 0-35.346-28.654-64-64-64C28.654 0 0 28.654 0 64c0 35.346 28.654 64 64 64zm-8-48c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24v56h16V96h16V80H96V56c0-22.091-17.909-40-40-40S16 33.909 16 56s17.909 40 40 40h16V80H56z"
      />
    </svg>
  );
}

export function RawIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 96 96"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16 40c0 13.255 10.745 24 24 24h16v16H40C17.909 80 0 62.091 0 40S17.909 0 40 0s40 17.909 40 40v24h16v16H80v16H64V40c0-13.255-10.745-24-24-24S16 26.745 16 40z" />
    </svg>
  );
}

export function SquareBottom(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h80V72c0-13.255-10.745-24-24-24S48 58.745 48 72s10.745 24 24 24h16v16H72c-22.091 0-40-17.909-40-40s17.909-40 40-40 40 17.909 40 40v24h16V16c0-8.837-7.163-16-16-16H16z" />
      <path d="M128 112h-16v16c8.837 0 16-7.163 16-16z" />
    </svg>
  );
}

export function SquareCenter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h96c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16zm40 80c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24v56h16V96h16V80H96V56c0-22.091-17.909-40-40-40S16 33.909 16 56s17.909 40 40 40h16V80H56z"
      />
    </svg>
  );
}
export function TwitterIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
    </svg>
  );
}

export function DiscordIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 33"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M13.104 13.424C12.192 13.424 11.472 14.224 11.472 15.2C11.472 16.176 12.208 16.976 13.104 16.976C14.016 16.976 14.736 16.176 14.736 15.2C14.752 14.224 14.016 13.424 13.104 13.424ZM18.944 13.424C18.032 13.424 17.312 14.224 17.312 15.2C17.312 16.176 18.048 16.976 18.944 16.976C19.856 16.976 20.576 16.176 20.576 15.2C20.576 14.224 19.856 13.424 18.944 13.424Z"
          fill="currentColor"
        />
        <path
          d="M26.72 0H5.28C3.472 0 2 1.472 2 3.296V24.928C2 26.752 3.472 28.224 5.28 28.224H23.424L22.576 25.264L24.624 27.168L26.56 28.96L30 32V3.296C30 1.472 28.528 0 26.72 0ZM20.544 20.896C20.544 20.896 19.968 20.208 19.488 19.6C21.584 19.008 22.384 17.696 22.384 17.696C21.728 18.128 21.104 18.432 20.544 18.64C19.744 18.976 18.976 19.2 18.224 19.328C16.8537 19.5803 15.4483 19.5749 14.08 19.312C13.2767 19.1548 12.4894 18.9245 11.728 18.624C11.3267 18.4697 10.9364 18.2879 10.56 18.08C10.512 18.048 10.464 18.032 10.416 18C10.384 17.984 10.368 17.968 10.352 17.952C10.064 17.792 9.904 17.68 9.904 17.68C9.904 17.68 10.672 18.96 12.704 19.568C12.224 20.176 11.632 20.896 11.632 20.896C8.096 20.784 6.752 18.464 6.752 18.464C6.752 13.312 9.056 9.136 9.056 9.136C11.36 7.408 13.552 7.456 13.552 7.456L13.712 7.648C10.832 8.48 9.504 9.744 9.504 9.744C9.504 9.744 9.856 9.552 10.448 9.28C12.16 8.528 13.52 8.32 14.08 8.272C14.176 8.256 14.256 8.24 14.352 8.24C17.1266 7.86446 19.9483 8.39179 22.4 9.744C22.4 9.744 21.136 8.544 18.416 7.712L18.64 7.456C18.64 7.456 20.832 7.408 23.136 9.136C23.136 9.136 25.44 13.312 25.44 18.464C25.44 18.464 24.08 20.784 20.544 20.896V20.896Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export function HowRareIsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.66663 5.33338V9.00004H6.66663V12H3.66663V15.5H6.66663V20.6667H10.8333V15.5H13.8333L16.1666 20.6667H20.5L17.3333 14.1667C19.1666 13.5001 22.1666 6.50008 14.8333 5.33338H10.8333V3.66675H6.66663V5.33338H3.66663ZM10.6667 8.66667V11.8333H14.3333C14.3333 11.8333 15.3333 11.3333 15.3333 10.1667C15.3333 9 14.3333 8.66667 14.3333 8.66667H10.6667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function WebsiteIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
      />
    </svg>
  );
}
